/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


/**
 * **Required Permission(s):** ORG_PAYEE_GET
 */
export const getTalentMemberSignInMethodsParams = zod.object({
  "id": zod.string().uuid()
})





export const getTalentMemberSignInMethodsResponse = zod.object({
  "ssoProviders": zod.array(zod.object({
  "id": zod.string().uuid(),
  "providerId": zod.string().min(1),
  "email": zod.string().min(1),
  "createdDate": zod.string().datetime({}),
  "lastUsedDate": zod.string().datetime({}).nullish()
})),
  "passkeyCount": zod.number()
})

